var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BoxWrap", { attrs: { title: _vm.$t("material.BoxWrap.manage") } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["LIST"] },
                expression: "{pageName, list: ['LIST']}",
              },
            ],
            staticClass: "action-container",
          },
          [
            _c(
              "el-form",
              { attrs: { size: "small", inline: "", "label-position": "top" } },
              [
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("material.input.materialCode"),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "material.input.inputHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.materialCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchVal, "materialCode", $$v)
                                },
                                expression: "searchVal.materialCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "material.input.materialDescription"
                              ),
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "material.input.inputHolder"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchVal.materialDescription,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchVal,
                                    "materialDescription",
                                    $$v
                                  )
                                },
                                expression: "searchVal.materialDescription",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "material.input.materialInnerStatus"
                              ),
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "material.input.optionPlaceholder"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.sapOffshelf,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "sapOffshelf", $$v)
                                  },
                                  expression: "searchVal.sapOffshelf",
                                },
                              },
                              _vm._l(
                                _vm.lookupList["PRODUCT_SAPOFFSHELF_STATUS"],
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 7 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("material.input.brand") } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "material.input.optionPlaceholder"
                                  ),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchVal.brand,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchVal, "brand", $$v)
                                  },
                                  expression: "searchVal.brand",
                                },
                              },
                              _vm._l(
                                _vm.lookupList["PRODUCT_BRAND"],
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "header-bottom-right" }, [
          _c(
            "div",
            { staticClass: "header-bottom-right-btn" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{pageName, list: ['LIST']}",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")))]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("material.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "materialCode",
                  label: _vm.$t("material.table.materialCode"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "materialDescription",
                  label: _vm.$t("material.table.materialDescription"),
                  width: "380",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("material.table.offshelf"),
                  width: "80",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "text-status ",
                            class:
                              scope.row.sapOffshelf === "Y"
                                ? "success"
                                : "warning",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  (_vm.lookupList[
                                    "PRODUCT_SAPOFFSHELF_STATUS_MAPPING"
                                  ] &&
                                    _vm.lookupList[
                                      "PRODUCT_SAPOFFSHELF_STATUS_MAPPING"
                                    ][scope.row.sapOffshelf]) ||
                                    scope.row.sapOffshelf
                                )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brand",
                  label: _vm.$t("material.table.brand"),
                  width: "80",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tyreSize",
                  label: _vm.$t("material.table.tyreSize"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pattern",
                  label: _vm.$t("material.table.pattern"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "ROFType",
                  label: _vm.$t("material.table.ROFType"),
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("material.table.action"),
                  fixed: "right",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "medium" } },
                          [
                            _c("el-button", {
                              staticClass: "t-square-btn t-more-btn",
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-more",
                                circle: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "FPermission",
                                        rawName: "v-FPermission",
                                        value: {
                                          pageName: _vm.pageName,
                                          list: ["ADD_EDIT"],
                                        },
                                        expression:
                                          "{pageName, list: ['ADD_EDIT']}",
                                      },
                                    ],
                                    staticClass: "t-square-btn t-green-btn",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      circle: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.editDetails(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.checkDetail")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }